"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRefreshResponse = exports.makeRefreshInstitutionLogin = exports.makeRefreshAggregator = exports.RefreshAccountsMfaFormSubmitError = exports.mkMfaResponse = exports.mkMfaAnswer = exports.mkMfaChallenge = exports.mkMfaChallengeItem = exports.mkMfaAnswerChoice = exports.mkInstitutionLoginsStore = exports.mkInstitutionLogin = exports.mkFiMigrationInfo = exports.mkCredential = exports.mkInstitutionLoginAggregator = void 0;
const immutable_1 = require("immutable");
const es6_error_1 = __importDefault(require("es6-error"));
exports.mkInstitutionLoginAggregator = (0, immutable_1.Record)({
    channel: null,
    cpId: null,
    aggStatus: null,
    aggStatusCode: null,
    aggStatusDetail: null,
    lastStatusUpdatedAt: null,
    lastRefreshSuccessfulAt: null,
    lastRefreshAttemptedAt: null,
});
exports.mkCredential = (0, immutable_1.Record)({
    key: 'unknown',
    value: 'unknown',
});
exports.mkFiMigrationInfo = (0, immutable_1.Record)({
    toInstitutionId: 'unknown',
    toChannel: 'unknown',
});
exports.mkInstitutionLogin = (0, immutable_1.Record)({
    id: undefined,
    name: 'unknown',
    institutionId: undefined,
    brandingId: undefined,
    cpInstitutionId: undefined,
    ewcLive: false,
    cpSetupMode: undefined,
    channel: undefined,
    credentials: undefined,
    aggregators: undefined,
    optionalAction: undefined,
    fiMigrationInfo: undefined,
    isDeleted: false,
});
exports.mkInstitutionLoginsStore = (0, immutable_1.Record)({
    resourcesById: (0, immutable_1.Map)(),
    lastSyncDate: null,
    loadPending: true,
    isLoading: false,
    isRefreshingAll: false,
    idsRefreshing: (0, immutable_1.Set)(),
    idsRefreshingWithUserActionsPending: (0, immutable_1.Set)(),
    idsRefreshingWithCancelledUserActions: (0, immutable_1.Set)(),
    credentialBlobsForRefreshingLogins: (0, immutable_1.Map)(),
    credentialsForRefreshingLogins: (0, immutable_1.Map)(),
});
exports.mkMfaAnswerChoice = (0, immutable_1.Record)({
    displayText: 'unknown',
});
exports.mkMfaChallengeItem = (0, immutable_1.Record)({
    type: 'QUESTION',
    key: '0',
    sequence: 0,
    base64Image: null,
    question: 'unknown',
    answerChoices: null,
});
exports.mkMfaChallenge = (0, immutable_1.Record)({
    institutionLoginId: '0',
    challenges: (0, immutable_1.List)(),
    submitUrl: '',
});
exports.mkMfaAnswer = (0, immutable_1.Record)({
    id: '0',
    value: 'unknown',
});
exports.mkMfaResponse = (0, immutable_1.Record)({
    institutionLoginId: '0',
    answers: (0, immutable_1.List)(),
    submitUrl: 'need_to_set_submit_url',
});
class RefreshAccountsMfaFormSubmitError extends es6_error_1.default {
    constructor(message, institutionLoginId) {
        super(message);
        this.institutionLoginId = institutionLoginId;
    }
}
exports.RefreshAccountsMfaFormSubmitError = RefreshAccountsMfaFormSubmitError;
exports.makeRefreshAggregator = (0, immutable_1.Record)({
    channel: undefined,
    isProcessing: false,
    aggStatus: undefined,
    cpAggStatus: undefined,
    cpAggStatusDetail: undefined,
    mfaChallenges: undefined,
    accounts: undefined,
});
exports.makeRefreshInstitutionLogin = (0, immutable_1.Record)({
    id: '0',
    isProcessing: false,
    status: 'OK',
    credentialsBlob: undefined,
    submitUrl: undefined,
    aggregators: undefined,
});
exports.makeRefreshResponse = (0, immutable_1.Record)({
    jobId: '0',
    isProcessing: false,
    status: 'OK',
    institutionLogins: (0, immutable_1.List)(),
});
